import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {catchError, from, Observable, of, switchMap} from "rxjs";
import {Location} from "@angular/common";
import {RcpService} from "../../lib/services/rcp/rcp.service";

@Injectable({
    providedIn: 'root'
})
class TemporalPasswordGuard {
    constructor(private router: Router,
                private location: Location,
                private rcpService: RcpService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const isTemporalPassword = this.rcpService.isTemporalPassword();
        if (isTemporalPassword) {
            return from(this.router.navigate(['/changeTemporalPassword'])).pipe(
                switchMap(() => of(true)),
                catchError((error) => {
                    return of(true);
                })
            );
        }
        return of(true);
    }


}

export const RequireChangePassword: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(TemporalPasswordGuard).canActivate(next, state)
}

